export default __webpack_public_path__ + "static/media/news46.9e7473f4.jpg";